export default __webpack_public_path__ + "static/media/a037-j.b991c068.jpg";